/*
 后台管理系统主路由组件
 */
import React, {Component} from 'react'
import {Layout, Icon, Badge, Popconfirm, Popover, Dropdown, Menu} from 'antd'
import {Link, withRouter} from 'react-router-dom'
import userUtils, {getUserInfo} from "../../utills/userUtils";
import QRCode from "qrcode.react";
import ajax from "../../api/ajax";
import {baseUrl} from '../../api'
import qrcodeIcon from "../icon/qrcode";
const {Header} = Layout;
const pathName = {
    "/": '首页',
    '/domesticList': '国内运输订单',
    '/trackList': '出口运输订单',
    '/orderTicket': '发起货运',
    '/deliveryList': '物流信息维护',
    '/importDeliveryList': '进口物流信息维护',
    '/trackInfo': '物流查询',
    '/orderInfo': '货运委托单',
    '/addrList': '地址管理',
    '/addrAdd': '地址管理',
    '/ordersub': '订单预警设置',
    '/usersub': '预警用户设置',
};
class HeaderMenu extends Component {
    state = {
        userMobileurl: "",
        priceMobileurl: "",
    };
    onVisibleChange = (type) => {
        getUserInfo().then((userInfo) => {
            this.getMobileUrl(userInfo, type)
        })
    };
    getMobileUrl = async (userInfo, type) => {
        if (userInfo && userInfo.username) {
            let result = await ajax(baseUrl + '/cors/sesstionid');
            if (result.code === 200) {
                let origin = window.location.origin;
                let wwwUrl = origin;
                if (origin) {
                    if (origin.indexOf("www") < 0) {
                        console.log(origin.indexOf("//"));
                        wwwUrl = origin.substr(origin.indexOf("//") + 2);
                        wwwUrl = 'http://www.' + wwwUrl;
                    }
                }
                let url;
                if (type === 'user') {
                    url = baseUrl + "/cors/login/" + result.data + "?url=" + encodeURIComponent(wwwUrl + "/crm/sub?type=" + type + "&value=" + userInfo.username);
                    this.setState({userMobileurl: url});
                } else {
                    url = baseUrl + "/cors/login/" + result.data + "?url=" + encodeURIComponent(wwwUrl + "/crm/sub/price");
                    this.setState({priceMobileurl: url});
                }
            }
        }
    };
    logout = () => {
        userUtils.doLogout()
    };

    componentWillMount() {
        getUserInfo().then((userInfo) => {
            this.getMobileUrl(userInfo, 'user');
            this.getMobileUrl(userInfo, 'price');
        })
    }

    render() {
        const path = this.props.location.pathname;
        const {userMobileurl, priceMobileurl} = this.state;
        const menuSub = (
            <Menu>
                <Menu.Item key="0">
                    <Link to='/usersub'>
                        <span>预警用户设置</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="1">
                    <Link to='/ordersub'>
                        <span>订单预警设置</span>
                    </Link>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="2">
                    <Popover content={(
                        <div>
                            <QRCode value={userMobileurl}/>
                        </div>
                    )} placement="left" onVisibleChange={() => this.onVisibleChange('user')}>
                        <Icon component={qrcodeIcon} style={{width: 14, height: 14}} className="header-manu-message"/>
                        <span>告警订阅</span>
                    </Popover>
                </Menu.Item>
                <Menu.Item key="3">
                    <Popover content={(
                        <div>
                            <QRCode value={priceMobileurl}/>
                        </div>
                    )} placement="left" onVisibleChange={() => this.onVisibleChange('price')}>
                        <Icon component={qrcodeIcon} style={{width: 14, height: 14}} className="header-manu-message"/>
                        <span>报价订阅</span>
                    </Popover>
                </Menu.Item>
            </Menu>
        );
        return (
            <Header className='header' style={{zIndex: '99999'}}>
                <div className='header-manu'>
                    <span className="header-manu-left">货运委托系统</span>
                    <span className="header-manu-right">
                        <span>
                            <Dropdown overlay={menuSub}>
                                <span className="ant-dropdown-link" href="#">
                                    <Icon component={qrcodeIcon} style={{width: 14, height: 14}}
                                          className="header-manu-message"/>
                                    <span>消息订阅</span><Icon type="down"/>
                                </span>
                            </Dropdown>
                            <Badge className="header-manu-messageNum"></Badge>
                        </span>
                        <span style={{cursor: 'pointer'}}>
                            <Popconfirm title="是否确定退出?" onConfirm={() => this.logout()} placement="bottomRight">
                                <Icon type="logout" className="header-manu-logout"/>
                                <span>退出</span>
                            </Popconfirm>
                        </span>
                    </span>
                </div>
                <div className="header-tab">
                    <Icon className="trigger" type={'menu-fold'}/>
                    <span className='header-tab-opt'>
                        <span>主页</span>
                        <Icon type="caret-right" className='header-tab-opt-icon'/>
                        <span>{pathName[path]}</span>
                    </span>
                </div>
            </Header>
        )
    }
}
export default withRouter(HeaderMenu)
